import { createSelector } from 'reselect';
import { getAllsureInsurance } from './index';
import { FORM_STATUS } from '../../reducers/status';
import { getGlobalPaymentFrequency } from './homeDetails';

export const getBankingDetails = createSelector(
    getAllsureInsurance,
    (allsureInsurance) => allsureInsurance.bankingDetails
);

export const getBankingDetailsForm = createSelector(getBankingDetails, (bankingDetails) => bankingDetails.form);
export const getBankingDetailsMaped = createSelector(getBankingDetailsForm, (bankingDetailsForm) =>
    Object.keys(bankingDetailsForm)
        .map((item) => ({ label: item, value: bankingDetailsForm[item]?.value }))
        .filter((element) => element.label !== 'paymentConfirmation')
);
export const getIsPersonalDetailsFormValid = createSelector(
    getBankingDetails,
    (bankingDetails) => bankingDetails.formStatus === FORM_STATUS.VALID
);
const inputFieldLabels = {
    paymentFrequency: 'How often would you like to pay your premium? *',
    bankName: 'Bank name *',
    branchCode: 'Branch code *',
    accountHolderName: 'Account holder name *',
    accountNumber: 'Account number *',
    accountType: 'Account type *',
    coverStartDate: 'Cover start date *',
    debitOrderDay: 'Debit order day *',
    sourceOfFund: 'Source of funds *',
    otherSourceofFund: 'Source of funds *',
    paymentConfirmation: 'Payment confirmation *',
};
export const getBankingDetailsSummary = createSelector(
    getBankingDetailsForm,
    getGlobalPaymentFrequency,
    (bankinDetailsForm, paymentFrequency) => {
        const { sourceOfFund } = bankinDetailsForm;
        const bankingPaymentFrequency = {
            label:inputFieldLabels.paymentFrequency,
            value:paymentFrequency
        }
        
        const excludeFields = [
            sourceOfFund.displayValue === 'Other' ? 'sourceOfFund' : 'otherSourceofFund', 'paymentConfirmation',
            paymentFrequency === 'Yearly' ? 'debitOrderDay' : '',
        ];
        
        const finalBankingSummary = Object.keys(bankinDetailsForm).flatMap((item) => {
            if (excludeFields.includes(item)) return [];
            return {
                label: inputFieldLabels[item],
                value: bankinDetailsForm[item]?.displayValue ?? '-',
            }; 
        });
        return [bankingPaymentFrequency, ...finalBankingSummary]
    }
);
